export function PrintQrCode({ location, ...rest }: any) {
  return <div />;
}
